import * as React from 'react';
import { PivotViewComponent, Inject, FieldList, CalculatedField, Toolbar, PDFExport, ExcelExport, ConditionalFormatting, NumberFormatting, VirtualScroll } from '@syncfusion/ej2-react-pivotview';
import { SampleBase } from '../../syncfusion/sample-base';
import { L10n, setCulture, setCurrencyCode } from '@syncfusion/ej2-base';
import { DataManager, WebApiAdaptor, Query } from '@syncfusion/ej2-data';
import { /* config, */ handleResponse } from '../../_helpers'
import { ProgressBarComponent } from '@syncfusion/ej2-react-progressbar';
import { authenticationService } from '../../_services'
import './pivotTableToolBar.css';
//import { pivotSettings } from './pivotTableDataSettings';


setCulture('es');
setCurrencyCode('COP');

let pivotCfgSettings;
let pivotCfgOptions;

let dataSourceSettings;
let reportOption;
let data1;

export class CustomWebApiAdaptor extends WebApiAdaptor {  
 /*    processResponse() {
        debugger
    } */

    beforeSend (dm, request,settings) { 

    }
} 

export class PivotTableToolBar extends SampleBase {
    constructor() {
        super(...arguments);

        this.state = {
            userData : {},
            language: {},
            loading: false,
            progress: 0,
            refresh: true
        }

        this.config = window.config;
        reportOption = this.props.opcion;
        dataSourceSettings=this.props.dataSourceSettings;
        this.gridoption = {
            //actionFailure={this.onActionFailure}
        }
        //dataSourceSettings.paginas = 10000;
        this.configSettings().then(res=>{
            
        }).catch(err=>{

        });
  
    }


    async updateReportDB(reports) {
        const name = reports.name;
        const user = reports.user;
        const option = reports.option;
        const reportname = reports.reportName;
        const report = reports.report;
        var raw = JSON.stringify({ name, user, option, reportname, report });
    
        var requestOptions = { 
            method: 'PUT',
            //mode: 'no-cors',
            headers: { "Content-Type": "application/json",
                        "api-token": `${authenticationService.currentUserValue.jwt_token}`   },
            body: raw,
            redirect: 'follow'
        };
        debugger;
        //this a sessionStorage
        const respuesta = await fetch( JSON.parse(sessionStorage.config).HostUrlAuth+"reports", requestOptions)
            .then(handleResponse)
            .then(resp => {
                debugger;
                return resp;
            })
            .catch(err => {
                debugger;
                Promise.reject('Error de conexion con reportes.')} );
        return respuesta;
    }

    progressLoad(args) {
        let selectedTheme = window.location.hash.split('/')[1];
        //selectedTheme = selectedTheme ? selectedTheme : 'Material';
        selectedTheme = selectedTheme ? selectedTheme : 'bootstrap4';
        args.progressBar.theme = (selectedTheme.charAt(0).toUpperCase() +
            selectedTheme.slice(1)).replace(/-dark/i, 'Dark').replace(/contrast/i, 'Contrast');
        switch (selectedTheme) {
            case 'material':
                args.progressBar.annotations[0].content = '<div id="point1" style="font-size:24px;font-weight:bold;color:#e91e63"><span></span></div>';
                break;
            case 'fabric':
                args.progressBar.annotations[0].content = '<div id="point1" style="font-size:24px;font-weight:bold;color:#0078D6"><span></span></div>';
                break;
            case 'bootstrap':
                args.progressBar.annotations[0].content = '<div id="point1" style="font-size:24px;font-weight:bold;color:#317ab9"><span></span></div>';
                break;
            case 'bootstrap4':
                args.progressBar.color = '#2437AF';
                args.progressBar.annotations[0].content = '<div id="point1" style="font-size:24px;font-weight:bold;color:#007bff"><span></span></div>';
                break;
            default:
                args.progressBar.trackColor = '#969696';
                args.progressBar.annotations[0].content = '<div id="point1" style="font-size:24px;font-weight:bold;color:#FFD939"><span></span></div>';
                break;
        }
    };

    async saveReportDB(reports) {
        const name = reports.name;
        const user = reports.user;
        const option = reports.option;
        const reportname = reports.reportName;
        const report = reports.report;
        var raw = JSON.stringify({ name, user, option, reportname, report });
        
        var requestOptions = { 
            method: 'POST',
            //mode: 'no-cors',
            headers: { "Content-Type": "application/json",
                        "api-token": `${authenticationService.currentUserValue.jwt_token}`   },
            body: raw,
            redirect: 'follow'
        };
        debugger;
        //this a sessionStorage
        const respuesta = await fetch( JSON.parse(sessionStorage.config).HostUrlAuth+"reports/addreport", requestOptions)
            .then(handleResponse)
            .then(resp => {
                //store user details and jwt token in local storage to keep user logged in between page refreshes
                //localStorage.setItem('currentUser', JSON.stringify(resp));
                //currentUserSubject.next(resp);

                return resp;
            })
            //.catch(err => Promise.reject('Error de autenticación! Por favor validar email o password.') );
            
        return respuesta;
    }

    async removeReportDB(reports) {
        const name = 'saveReport';
        const user = authenticationService.currentUserValue.usuario.email;
        const option = reportOption;
        const reportname = reports.reportName;
        //const report = reports.report;
        var raw = JSON.stringify({ name, user, option, reportname });
    
        var requestOptions = { 
            method: 'DELETE',
            //mode: 'no-cors',
            headers: { "Content-Type": "application/json",
                        "api-token": `${authenticationService.currentUserValue.jwt_token}`   },
            body: raw,
            redirect: 'follow'
        };
        debugger;
        //this a sessionStorage
        const respuesta = await fetch( JSON.parse(sessionStorage.config).HostUrlAuth+"reports", requestOptions)
            .then(handleResponse)
            .then(resp => {
                //store user details and jwt token in local storage to keep user logged in between page refreshes
                //localStorage.setItem('currentUser', JSON.stringify(resp));
                //currentUserSubject.next(resp);

                return resp;
            })
            //.catch(err => Promise.reject('Error de autenticación! Por favor validar email o password.') );
            
        return respuesta;
    }

    saveReport(args) {
        let reports = [];
        let report_tmp = {};
        let isSaved = false;

        if (localStorage.pivotviewReports && localStorage.pivotviewReports !== "") {
            //reports = JSON.parse(localStorage.pivotviewReports);
            reports = JSON.parse(localStorage.pivotviewReports);
        }

        if (args.report && args.reportName && args.reportName !== '') {
            
            report_tmp.name = args.name;
            report_tmp.report = JSON.parse(args.report);
            report_tmp.reportName = args.reportName;
            report_tmp.report.dataSourceSettings.dataSource = {};
            report_tmp.report.pivotValues= [];
            report_tmp.option = this.props.opcion;
            report_tmp.user = authenticationService.currentUserValue.usuario.email;
            report_tmp.report = JSON.stringify(report_tmp.report);
            
            // eslint-disable-next-line
            reports.map(function (item) {
                if (args.reportName === item.reportName && item.option === reportOption && item.user === authenticationService.currentUserValue.usuario.email) {
                    //item.report = args.report;
                    item.report = report_tmp.report;
                    item.option = reportOption;
                    item.user = authenticationService.currentUserValue.usuario.email;
                    isSaved = true;
                }
            });
            if (!isSaved) {
                //reports.push(args);
                reports.push(report_tmp);
                this.saveReportDB(report_tmp);
            } else {
                this.updateReportDB(report_tmp);
            }

            localStorage.pivotviewReports = JSON.stringify(reports);
        }
    }
    fetchReport(args) {
        
        let reportCollection = [];
        let reeportList = [];
        if (localStorage.pivotviewReports && localStorage.pivotviewReports !== "") {
            reportCollection = JSON.parse(localStorage.pivotviewReports);
        }

       // eslint-disable-next-line 
        reportCollection.map(function (item) { 
                    if (item.option === reportOption && item.user === authenticationService.currentUserValue.usuario.email) {
                            reeportList.push(item.reportName); 
                    }
            });
        args.reportName = reeportList;
    }
    loadReport(args) {
        let reportCollection = [];
        let report_tmp;
        if (localStorage.pivotviewReports && localStorage.pivotviewReports !== "") {

            reportCollection = JSON.parse(localStorage.pivotviewReports);
        }
        // eslint-disable-next-line
        reportCollection.map(function (item) {
            if (args.reportName === item.reportName && item.option === reportOption && item.user === authenticationService.currentUserValue.usuario.email) {
                args.report = item.report;
            }
        });
        if (args.report) {
            report_tmp = JSON.parse(args.report);
            report_tmp.dataSourceSettings.dataSource = this.pivotObj.dataSourceSettings.dataSource;
            //this.pivotObj.dataSourceSettings = JSON.parse(args.report).dataSourceSettings;

            this.pivotObj.dataSourceSettings = report_tmp.dataSourceSettings;

            //this.pivotObj.dataSourceSettings.dataSource = this.data;
        }

    }
    removeReport(args) {
        let reportCollection = [];
        if (localStorage.pivotviewReports && localStorage.pivotviewReports !== "") {
            reportCollection = JSON.parse(localStorage.pivotviewReports);
        }
        for (let i = 0; i < reportCollection.length; i++) {
            if (reportCollection[i].reportName === args.reportName && reportCollection[i].option === reportOption && reportCollection[i].user === authenticationService.currentUserValue.usuario.email) {
                reportCollection.splice(i, 1);
            }
        }
        if (localStorage.pivotviewReports && localStorage.pivotviewReports !== "") {
            localStorage.pivotviewReports = JSON.stringify(reportCollection);
            this.removeReportDB(args);
        }
    }

    renameReport(args) {
        let reportsCollection = [];
        let reportRename = {};
        let isRenamed = false;

        if (localStorage.pivotviewReports && localStorage.pivotviewReports !== "") {
            reportsCollection = JSON.parse(localStorage.pivotviewReports);
        }
        if (args.isReportExists) {
            for (let i = 0; i < reportsCollection.length; i++) {
                if (reportsCollection[i].reportName === args.rename && reportsCollection[i].option === reportOption && reportsCollection[i].user === authenticationService.currentUserValue.usuario.email) {
                    reportsCollection.splice(i, 1);
                }
            }
        }
        // eslint-disable-next-line
        reportsCollection.map(function (item) { 
                if (args.reportName === item.reportName && item.option === reportOption && item.user === authenticationService.currentUserValue.usuario.email) {
                    item.reportName = args.rename;
                    reportRename = {name : 'saveReport',
                                    user: authenticationService.currentUserValue.usuario.email,
                                    option: reportOption,
                                    reportName: args.reportName,
                                    report: item.report}
                    isRenamed = true;
            } });
        if (isRenamed) {
            this.removeReportDB(reportRename);
            reportRename.reportName = args.rename;
            this.saveReportDB(reportRename);
        }
        if (localStorage.pivotviewReports && localStorage.pivotviewReports !== "") {
            localStorage.pivotviewReports = JSON.stringify(reportsCollection);
        }
    }
    newReport() {
        //console.log(this.pivotObj);
        this.pivotObj.setProperties({ dataSourceSettings: { columns: [], rows: [], values: [], filters: []} }, false);
        //this.setState({loading: false});
        this.pivotObj.refreshData();
    }
    beforeToolbarRender(args) {
        args.customToolbar.splice(6, 0, {
            type: 'Separator'
        });
        args.customToolbar.splice(9, 0, {
            type: 'Separator'
        });
    }
    chartOnLoad(args) {
        let selectedTheme = window.location.hash.split("/")[1];
        //selectedTheme = selectedTheme ? selectedTheme : "Material";
        selectedTheme = selectedTheme ? selectedTheme : "bootstrap4";
        args.chart.theme =
            selectedTheme.charAt(0).toUpperCase() + selectedTheme.slice(1);
        console.log('fin '+this.props.opcion)
        console.log(new Date());
    }

    onClickTabla () {
            console.log('click tabla');
            console.log(this.pivotObj);
            //console.log(this.pivotObj.dataSourceSettings.dataSource.requests[0].httpRequest.response);
        }

     fieldListRefreshed () {
        //debugger;
            console.log('cerrarfieldlist');
            //console.log(this.pivotObj);
            
            //this.pivotObj.refreshData();
    }
    toolbarClick() {
        debugger;
        this.pivotObj.grid.showSpinner();
    }
    afterPopulate(args) {
        let dataCaption = {}; 
        if (pivotCfgSettings[this.props.opcion].captions) {
            dataCaption = pivotCfgSettings[this.props.opcion].captions; 
        }
      
        Object.keys(this.pivotObj.engineModule.fieldList).forEach((key, index) => {
            if (dataCaption[key]) {
                this.pivotObj.engineModule.fieldList[key].caption = dataCaption[key].caption;
            }
            
        });
    }

/*     componentDidMount() {
        debugger;
        
    } */

    async configSettings() {
        
        L10n.load(JSON.parse(authenticationService.currentUserValue.usuario.objetos.replace(/'/g,"\"")));
        pivotCfgSettings = authenticationService.currentUserValue.usuario.configuracion.replace(/'/g,"\"");
        //debugger;
        pivotCfgSettings = pivotCfgSettings.replace(/: False/g,": false");
        pivotCfgSettings = pivotCfgSettings.replace(/: True/g,": true");
        pivotCfgSettings = JSON.parse(pivotCfgSettings).pivotview[authenticationService.currentUserValue.usuario.idioma];
        pivotCfgOptions = JSON.parse(authenticationService.currentUserValue.usuario.visualizar.replace(/'/g,"\""))['pivotview'];
        this.toolbarOptions = pivotCfgOptions;
        this.displayFieldList = false;
        
 

        if (!pivotCfgSettings[this.props.opcion].puerto) {
            pivotCfgSettings[this.props.opcion].puerto = '5002';
        }

        if (pivotCfgSettings[this.props.opcion].endpoint) {
            this.endpoint = pivotCfgSettings[this.props.opcion].endpoint
        }
        else {
            this.endpoint = this.props.opcion + '/'
        }
        console.log('inicio '+this.props.opcion)
        console.log(new Date());
        debugger;
        if ( !this.props.arch_json && !this.props.arch_csv ) {
            //this.data = new DataManager({ url: config.HostUrl+':'+ this.props.puerto + '/api/v1/'  + this.props.opcion + '/', 
            //localStorage.setItem('data1','')
            
            if (pivotCfgSettings[this.props.opcion].settings.paginas && pivotCfgSettings[this.props.opcion].settings.paginas>0) {
                this.state.loading = true;
                data1 = {data:[],pagina:1,paginas:1};
                sessionStorage.data1_inicio = false;
                do {
                    try
                    {
                        //this a sessionStorage
                        var datos = await new DataManager({ url: JSON.parse(sessionStorage.config).HostUrl + pivotCfgSettings[this.props.opcion].puerto + JSON.parse(sessionStorage.config).HostEndUrl + this.endpoint, 
                            adaptor: new WebApiAdaptor(),
                            headers:[{ "Content-Type":  "application / json",
                                        "api-token": `${authenticationService.currentUserValue.jwt_token}`   
                                    }],
                            crossDomain: true});
                        let resp = await datos.executeQuery(new Query().page(data1.pagina,pivotCfgSettings[this.props.opcion].settings.paginas));
                        //debugger
                        sessionStorage.data1_inicio = true;
                        data1.data = data1.data.concat(resp.result.data);
                        data1.paginas = resp.result.paginas;
                        data1.pagina++;
                        console.log(data1.pagina+' de '+data1.paginas)
                        if (this.linearBar.value) {
                            this.linearBar.value = (data1.pagina/data1.paginas)*100;
                            this.setState({progres: this.linearBar.value});
                        }
                    }catch(ex){
                        console.log(ex);
                    }
                   
                } while (data1.pagina <= data1.paginas)
                
                //this.data =  datos;
                dataSourceSettings = pivotCfgSettings[this.props.opcion].settings;
                dataSourceSettings.dataSource = data1.data;
                this.setState({loading: false});
            } else {
                this.state.loading = false;
                //pivotCfgSettings[this.props.opcion].puerto = 5051;
                //this a sessionStorage
                this.data = new DataManager({ url: JSON.parse(sessionStorage.config).HostUrl + pivotCfgSettings[this.props.opcion].puerto + JSON.parse(sessionStorage.config).HostEndUrl + this.endpoint, 
                                adaptor: new CustomWebApiAdaptor(),
                                headers:[{ "Content-Type":  "application / json",
                                            "api-token": `${authenticationService.currentUserValue.jwt_token}`   
                                        }],
                                crossDomain: true});
                dataSourceSettings = pivotCfgSettings[this.props.opcion].settings;
                dataSourceSettings.dataSource=this.data;

                /* this.data = new DataManager({ url: config.HostUrl + pivotCfgSettings[this.props.opcion].puerto + config.HostEndUrl + this.endpoint, 
                                adaptor: new CustomWebApiAdaptor(),
                                headers:[{ "Content-Type":  "application / json",
                                            "api-token": `${authenticationService.currentUserValue.jwt_token}`   
                                        }],
                                crossDomain: true}).executeQuery(new Query()).then((e) => {
                                        debugger;
                                        this.pivotObj.dataSourceSettings = pivotCfgSettings[this.props.opcion].settings;
                                        this.pivotObj.dataSourceSettings = {
                                            dataSource: e.result
                                        };
                                        this.pivotObj.grid.hideSpinner();
                                    }); */

            }
        } if (this.props.arch_csv && this.props.arch_csv===true) {
            debugger;
            this.state.loading = false;
            //pivotCfgSettings[this.props.opcion].puerto = 5051;
            /* this.data = new DataManager({ url: config.HostUrl + pivotCfgSettings[this.props.opcion].puerto + config.HostEndUrl + this.endpoint, 
                            adaptor: new CustomWebApiAdaptor(),
                            headers:[{ "Content-Type":  "application / json",
                                        "api-token": `${authenticationService.currentUserValue.jwt_token}`   
                                    }],
                            crossDomain: true}); */
            dataSourceSettings = pivotCfgSettings[this.props.opcion].settings;
            dataSourceSettings.type = 'CSV';
            //this a sessionStorage
            dataSourceSettings.url = JSON.parse(sessionStorage.config).HostUrl + pivotCfgSettings[this.props.opcion].puerto + JSON.parse(sessionStorage.config).HostEndUrl + this.endpoint;
            //dataSourceSettings.dataSource=this.data;

        }
        else {
            this.state.loading = false;
            pivotCfgSettings[this.props.opcion].settings.dataSource=dataSourceSettings.dataSource;
            dataSourceSettings = pivotCfgSettings[this.props.opcion].settings;
        };

        console.log('fin '+this.props.opcion+new Date());
        if (pivotCfgOptions.find( vOption => vOption === 'FieldList' )==='FieldList') {
            this.displayFieldList = true;
        }

        this.chartSettings= {
                palettes: ['#6050DC','#d52db7','#ff2e7e','#ff6b45','#ffab05','#385a7c','#f97171','#f99192','#8ad6cc','#b2eee6', '#E94649', '#F6B53F', '#6FAAB0', '#C4C24A'],
                title: pivotCfgSettings[this.props.opcion].title,
                load: this.chartOnLoad.bind(this),
                chartSeries:{type:'Column'}};
    }
    
    render() {
        debugger;
        const { idioma } = authenticationService.currentUserValue.usuario;
        // this.configSettings();
        if (this.state.loading === true) {
            return (
                <div className='control-pane'> Cargando...
                    <div className='control-section' id={this.props.pts_id} style={{ overflow: 'initial' }}>    
                        <ProgressBarComponent id="warning" ref={linear => this.linearBar = linear} type='Linear' height='40' width='97%' 
                            segmentCount={100}
                            showProgressValue={true} value={1} trackThickness={24} progressThickness={24} 
                            labelStyle={{
                                            textAlignment: 'Center',
                                            /* text: '60% Complete (Warning)', */
                                            color: '#941F0F'
                                        }}  role='Info' 
                            animation={{
                                            enable: false,
                                            duration: 0,
                                            delay: 0,
                                        }} 
                            load={this.progressLoad.bind(this)}>
                        </ProgressBarComponent>
                    </div>
                </div>
                );
        }
        else {
        return (<div className='control-pane'>
                <div className='control-section' id={this.props.pts_id} style={{ overflow: 'initial' }}>
                    <PivotViewComponent id={this.props.pv_id} ref={(scope) => { this.pivotObj = scope; }} 
                        dataSourceSettings={dataSourceSettings}
                        locale = {idioma} height= '475'  chartSettings= {this.chartSettings}
                        enableVirtualization={true} //allowDataCompression={true} 
                        enginePopulated={this.afterPopulate.bind(this)}
                        toolbarClick={this.toolbarClick.bind(this)}
                        /* allowDeferLayoutUpdate = {true} */
                        
                        /* fieldlistModule = {{element:{onclose : this.onCloseFieldList.bind(this)}}} */
                        fieldListRefreshed={this.fieldListRefreshed.bind(this)}
                        showFieldList={this.displayFieldList} gridSettings={{ columnWidth: 100 }} allowExcelExport={true} 
                        allowNumberFormatting={true} allowConditionalFormatting={true} allowPdfExport={true} 
                        showToolbar={true} allowCalculatedField={true} displayOption={{ view: 'Both', primary: 'Chart' }} 
                        toolbar={this.toolbarOptions} newReport={this.newReport.bind(this)} 
                        renameReport={this.renameReport.bind(this)} removeReport={this.removeReport.bind(this)} 
                        loadReport={this.loadReport.bind(this)} fetchReport={this.fetchReport.bind(this)} 
                        saveReport={this.saveReport.bind(this)} toolbarRender={this.beforeToolbarRender.bind(this)} 
                        /* chartSettings={{ title: 'Analisis de Ventas', load: this.chartOnLoad.bind(this) }} */
                        onClick = {this.onClickTabla = this.onClickTabla.bind(this)}>
                            <Inject services={[ FieldList,  CalculatedField, Toolbar, PDFExport, 
                                ExcelExport, ConditionalFormatting, NumberFormatting, VirtualScroll]}/>
                    </PivotViewComponent>
                </div>

            </div>);
    }
    }
}